import { Component } from '@angular/core';

@Component({ selector: 'app-settings', templateUrl: './settings.component.html', styleUrl: './settings.component.css' })
export class SettingsComponent {
  activeTab = 'general';

  settings = [
    { id: 1, key: 'App Name',              value: 'SignaTech',          category: 'General',  status: 'active' },
    { id: 2, key: 'Default Language',      value: 'English (US)',       category: 'General',  status: 'active' },
    { id: 3, key: 'Timezone',              value: 'UTC-05:00 (EST)',    category: 'General',  status: 'active' },
    { id: 4, key: 'Date Format',           value: 'MM/DD/YYYY',         category: 'General',  status: 'active' },
    { id: 5, key: 'Session Timeout',       value: '30 minutes',         category: 'Security', status: 'active' },
    { id: 6, key: 'Two-Factor Auth',       value: 'Enabled',            category: 'Security', status: 'active' },
    { id: 7, key: 'Password Policy',       value: 'Strong (8+ chars)',  category: 'Security', status: 'active' },
    { id: 8, key: 'Email Notifications',   value: 'Enabled',            category: 'Notifications', status: 'active' },
    { id: 9, key: 'Content Sync Interval', value: 'Every 5 minutes',    category: 'Display',  status: 'active' },
    { id: 10, key: 'Default Resolution',   value: '1920×1080',          category: 'Display',  status: 'active' },
  ];
}
